import { API } from './resources'

export default {
  createRegionBanner: (data) => {
    return API.post('/regionBanner', data)
  },
  createBannerSet: (data) => {
    return API.post('/bannerSet', data)
  },
  addBannersToCarousel: (data) => {
    return API.post('/carouselBanners', data)
  },
  updateDefaultSet: (bannerSetID) => {
    return API.post(`/bannerSet/defaultSet/${bannerSetID}`)
  },
  /* Get banners that have not been assigned to the specific set and partner */
  getBanners: (setID) => {
    return API.post(`/banners/${setID}`)
  },

  /*  Gets the banners in the Carousel with the specific SetID */
  getBannersBySet: (setID) => {
    return API.post(`/bannerSet/${setID}/banners`)
  },

  /* Gets the Carousel Names */
  getBannerSetsByPartner: (partnerID) => {
    return API.post(`/bannerSets/${partnerID}`)
  },

  /* Gets only Banner Sets that have banners assigned to them */
  getAllocatedBannerSetsByPartner: (partnerID) => {
    return API.get(`/bannerSets/allocated/${partnerID}`)
  },

  /* Gets only Banner Sets that have banners assigned to them */
  getCategoriesByPartner: (partnerSlug) => {
    return API.get(`/categorySet/categories/${partnerSlug}`)
  },

  /* Delete the Carousel */
  deleteBannerSet: (bannerSetID) => {
    return API.post(`/bannerSet/delete/${bannerSetID}`)
  },

  /* Delete the association between the banner and the Set */
  deleteBannerFromSet: (bannerID, data) => {
    return API.post(`/banner/delete/${bannerID}`, data)
  },

  createSponsors: (data) => {
    return API.post('/sponsor', data)
  },
  delete: (bannerID, data) => {
    return API.delete(`/banner/${bannerID}/delete`, { params: data })
  },
  deleteSponsor: (sponsorID, data) => {
    return API.delete(`/sponsor/${sponsorID}/delete`, { params: data })
  },

  createCategorySet: (data) => {
    return API.post('/categorySet', data)
  },
  getCategorySets: (partnerID) => {
    return API.post(`/categorySets/${partnerID}`)
  },
  saveCategorySet: (data) => {
    return API.post('/categorySet/save', data)
  },
  createCategoryBanner: (data) => {
    return API.post('/categoryBanner', data)
  },
  updateCategorySet: (categorySetID, data) => {
    return API.put(`/categorySet/update/${categorySetID}`, data)
  },
  deleteCategorySet: (categorySetID) => {
    return API.delete(`/categorySet/delete/${categorySetID}`)
  },
  getCategorySetsForCategoryPage: (partner, data) => {
    return API.get(`/categorySet/page/${partner}`, { params: data })
  },
  getBannerSetForNonCategoryPage: (bannerSetName) => {
    return API.get(`/categorySet/bannerSet/${bannerSetName}`)
  },
  getBannerButtonsForCategoryPage: (partner, data) => {
    return API.get(`/categorySet/bannerButtons/${partner}`, { params: data })
  },
  getBannerButtonsForNonCategoryPage: (bannerSetName) => {
    return API.get(`/categorySet/bannerSet/buttons/${bannerSetName}`)
  },
  getShowBannerForCategoryFlag: (category) => {
    return API.get(`/categorySet/showBanner/${category}`)
  }
}
